import { useMemo } from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'

import { formatAddress, getFormattedDateTime } from '../../utils/helpers'
import SimpleTable from '../simple-table'

const columns = [
  {
    field: 'date',
    headerName: 'Date',
    flex: 1,
    sortable: false,
  },
  {
    field: 'activity',
    headerName: 'Activity',
    flex: 1,
    sortable: false,
  },
  {
    field: 'location',
    headerName: 'Location',
    flex: 1,
    sortable: false,
  },
] satisfies GridColDef[]

const OrderTrackingTable = ({ timeline }: { timeline: IOrderDetail['timeline'] }) => {
  const rows = useMemo(
    () =>
      timeline
        .sort((a, b) => (new Date(a.updatedAt) < new Date(b.updatedAt) ? 1 : -1))
        .map((trackingItem, idx) => ({
          id: idx,
          date: trackingItem.updatedAt ? getFormattedDateTime(trackingItem.updatedAt) : '-',
          activity: trackingItem.message,
          location: formatAddress(
            `${trackingItem.location.city}, ${trackingItem.location.state}, ${trackingItem.location.country}`,
            trackingItem.location.country
          ),
        })),
    [timeline]
  )

  return <SimpleTable columns={columns} rows={rows} />
}

export default OrderTrackingTable
